export interface PublicAgencyTypesTypes {
  id: number;
  codigo: string;
  nome: string;
}

export const PublicAgencyTypes: Array<PublicAgencyTypesTypes> = [
  {
    id: 1,
    codigo: 'M',
    nome: 'Municipal',
  },
  {
    id: 2,
    codigo: 'E',
    nome: 'Estadual',
  },
  {
    id: 3,
    codigo: 'F',
    nome: 'Federal',
  },
  {
    id: 4,
    codigo: 'D',
    nome: 'Distrital',
  },
  {
    id: 5,
    codigo: 'P',
    nome: 'Privado',
  },
  {
    id: 6,
    codigo: 'ES',
    nome: 'Estatais',
  },
];
